import { getPath } from '@/router/common'

const baseUrl = {
  title: '报表过滤',
  path: 'Common'
}

export default [
  {
    path: getPath('RptFilter', baseUrl),
    name: 'RptFilter',
    component: () =>
      import(
        /* webpackChunkName: "RptFilter" */ '@/views/common/rptFilter/index.vue'
      ),
    meta: {
      title: '报表过滤'
    }
  }
]
